import React from 'react';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BaseButton } from '../../../../../../../BaseComponents';
const FooterLinks = ({ className, onClickRules, onClickConditions, isFareRulesDisabled }) => {
    const { FooterLinks: css } = useTheme('Entities').FareGroupV2;
    const { t } = useTranslation('FareGroup');
    return (React.createElement("div", { className: cn(css.root, className, { [css.oneLink]: !onClickRules || !onClickConditions }) },
        React.createElement(BaseButton, { className: css.rules, variant: "text", onClick: onClickRules, disabled: isFareRulesDisabled }, t('Fare rules')),
        !!onClickConditions && (React.createElement(BaseButton, { className: css.conditions, variant: "text", onClick: onClickConditions }, t('View full conditions')))));
};
export default FooterLinks;
